module.exports = __webpack_public_path__ + "img/zip.69807247.png";